import { DirectionDisplaySettingEntity } from 'src/entities/DirectionDisplaySetting.entity';
import { DisplayOperationColumnEntity } from 'src/entities/DisplayOperationColumn.entity';

// 時間帯の統合列キー（API には存在せず、時間枠①〜③をフロントで結合して生成する）。
export const LOAD_TIME_WINDOW_COLUMN = '積地時間帯';
export const DELIVERY_TIME_WINDOW_COLUMN = '降地時間帯';

// 開始/終了①〜③を「開始-終了」のカンマ区切りに結合する（空の枠は除外。片方のみならその値）。
export function combineTimeWindows(
  row: DisplayOperationColumnEntity[],
  prefix: '積地時間枠' | '降地時間枠',
): string {
  return ['', '②', '③']
    .map((suffix) => {
      const start = row.find((r) => r.key === `${prefix}/開始${suffix}`)?.value;
      const end = row.find((r) => r.key === `${prefix}/終了${suffix}`)?.value;
      if (!start && !end) return '';
      if (start && end) return `${start}-${end}`;
      return start || end || '';
    })
    .filter(Boolean)
    .join(',');
}

// 既存の保存設定に含まれる時間枠列（開始/終了①〜③）を、新しい「時間帯」1列に変換する。
// 同じ時間帯に集約される列が複数あっても、先頭出現位置で1つにまとめる（重複排除）。
export function convertTimeWindowSettings(
  settings: DirectionDisplaySettingEntity[],
): DirectionDisplaySettingEntity[] {
  const result: DirectionDisplaySettingEntity[] = [];
  const seen = new Set<string>();
  settings.forEach((setting) => {
    // localStorage 由来の破損データ（null 要素・id 非文字列）でも crash しないよう防御。
    if (!setting || typeof setting.id !== 'string') return;
    let { id, title } = setting;
    if (id.startsWith('積地時間枠')) {
      id = LOAD_TIME_WINDOW_COLUMN;
      title = LOAD_TIME_WINDOW_COLUMN;
    } else if (id.startsWith('降地時間枠')) {
      id = DELIVERY_TIME_WINDOW_COLUMN;
      title = DELIVERY_TIME_WINDOW_COLUMN;
    }
    if (seen.has(id)) return;
    seen.add(id);
    result.push({ id, title });
  });
  return result;
}
